<template>
  <div class="page-container">
    <div class="register-wrapper">
      <div class="regitster-logo-wrap flex">
        <img src="../assets/image/cl_register_logo.png" alt="" />
      </div>
      <div class="regitster-form-wrap">
        <div class="register-text">忘记密码</div>
        <div class="register-form-container">
          <el-form
            :model="newPswForm"
            :disabled="forbitSetPsw"
            :rules="passwordRules"
            ref="newPswForm"
            label-width="120px"
            class="account-login-form"
          >
            <el-form-item label="手机号" prop="mobile" class="regist-form-item">
              <el-input
                ref="userMobile"
                type="text"
                v-model="newPswForm.mobile"
                placeholder="输入已注册传联的手机号"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="短信验证码"
              prop="code"
              class="regist-form-item"
            >
              <div class="sefety-item-input flex">
                <el-input
                  v-model="newPswForm.code"
                  @blur="checkSMScode"
                  placeholder="输入验证码"
                ></el-input>
                <el-button
                  :disabled="banGetCode"
                  class="get-code-btn"
                  @click="getCode"
                  >{{ getCodeText }}</el-button
                >
              </div>
            </el-form-item>
            <el-form-item
              label="传联号"
              class="regist-form-item"
              v-show="showHandNum"
            >
              <el-input
                type="text"
                :disabled="true"
                v-model="newPswForm.handLianNum"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="设置新密码"
              prop="password"
              class="regist-form-item"
            >
              <el-input
                show-password
                v-model="newPswForm.password"
                placeholder="6-20个字符（最好不是纯数字）"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="确 认 密 码"
              prop="confirmPsw"
              class="regist-form-item"
            >
              <el-input
                show-password
                v-model="newPswForm.confirmPsw"
                placeholder="再次输入新密码"
              ></el-input>
            </el-form-item>
            <el-form-item class="submit-item">
              <el-button
                type="primary"
                class="handlian-btn"
                @click="submitForm('newPswForm')"
                >确定</el-button
              >
              <el-button class="handlian-btn" @click="resetForm('newPswForm')"
                >重置</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Footer from "../components/Footer";
import { apiMap } from "../utils/apiMap";
export default {
  name: "register",
  data() {
    let _this = this;
    var validateMobile = (rule, value, callback) => {
      var mobileRegExp = /^1[345789]\d{9}$/;
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!mobileRegExp.test(value)) {
        callback(new Error("手机号格式不正确"));
      } else {
        callback();
      }
    };
    var validateCode = (rule, value, callback) => {
      var numberRegExp = /^[0-9]+$/;
      if (value === "") {
        callback(new Error("请输入验证码"));
      } else if (!numberRegExp.test(value)) {
        callback(new Error("请输入数字验证码"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.newPswForm.password) {
        callback(new Error("两次输入密码不一致"));
      } else {
        callback();
      }
    };
    return {
      forbitSetPsw: false,
      banGetCode: false,
      showHandNum: false,
      newPswForm: {
        mobile: "",
        code: "",
        handLianNum: "",
        password: "",
        confirmPsw: "",
      },
      passwordRules: {
        mobile: [{ validator: validateMobile, trigger: "blur" }],
        code: [{ validator: validateCode, trigger: "blur" }],
        password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "长度在 6 到 20 个字符",
            trigger: "blur",
          },
        ],
        confirmPsw: [{ validator: validatePass, trigger: "blur" }],
      },
      getCodeText: "发送短信",
      banGetCode: false,
      timer: null,
    };
  },
  components: {
    Footer,
  },
  methods: {
    submitForm(formName) {
      let _this = this;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          if (_this.newPswForm.handLianNum !== "") {
            let paramArr = [
              `handNum=${_this.newPswForm.handLianNum}`,
              `password=${_this.newPswForm.password}`,
              `notpassword=${_this.newPswForm.confirmPsw}`,
            ];
            _this.changePassword(paramArr);
            _this.forbitSetPsw = true;
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.newPswForm.handLianNum = "";
      this.showHandNum = false;
      this.forbitSetPsw = false;
    },
    checkSMScode() {
      let _this = this;
      if (_this.newPswForm.mobile && _this.newPswForm.code) {
        _this
          .$axios({
            baseURL: apiMap["commonUrl"],
            method: apiMap["checkCode"]["method"],
            url: apiMap["checkCode"]["url"],
            data: `mobile=${_this.newPswForm.mobile}&code=${_this.newPswForm.code}&scene=2`,
          })
          .then(function (response) {
            if (response.data.result.statusCode == 1) {
              _this.getHandNumber();
            } else {
              _this.$alert(response.data.result.data, {
                confirmButtonText: "确定",
                showClose: false,
              });
            }
          });
      }
    },
    getHandNumber() {
      let _this = this;
      if (_this.newPswForm.mobile && _this.newPswForm.code) {
        _this
          .$axios({
            baseURL: apiMap["commonUrl"],
            method: apiMap["getHandNumber"]["method"],
            url: apiMap["getHandNumber"]["url"],
            data: `mobile=${_this.newPswForm.mobile}&code=${_this.newPswForm.code}`,
          })
          .then(function (response) {
            if (response.data.result.statusCode == 1) {
              _this.newPswForm.handLianNum = response.data.result.data;
              _this.showHandNum = true;
            } else {
              _this.$alert(response.data.result.data, {
                confirmButtonText: "确定",
                showClose: false,
              });
            }
          });
      }
    },
    getCode() {
      let _this = this;
      _this.$refs["newPswForm"].validateField("mobile", (error) => {
        if (!error) {
          let newMobile = _this.$refs.userMobile.value;
          if (newMobile) {
            _this.sendCode(function (respond) {
              if (respond.statusCode == 1) {
                _this.$notify({
                  title: "提示",
                  message: "验证码发送成功",
                  type: "success",
                });
                _this.countSecondDown();
              } else {
                _this.$alert(respond.data, {
                  confirmButtonText: "确定",
                  showClose: false,
                });
              }
            });
          }
        }
      });
    },
    sendCode(okCBK) {
      let _this = this;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["verifyCode"]["method"],
          url: apiMap["verifyCode"]["url"],
          data: `mobile=${this.$refs.userMobile.value}&scene=2`,
        })
        .then(function (response) {
          okCBK(response.data.result);
        });
    },
    countSecondDown() {
      const TIME_COUNT = 59;
      if (!this.timer) {
        var count = TIME_COUNT;
        this.banGetCode = true;
        this.timer = setInterval(() => {
          if (count > 0 && count <= TIME_COUNT) {
            this.getCodeText = `发送短信(${count--})`;
          } else {
            clearInterval(this.timer);
            this.timer = null;
            this.banGetCode = false;
            this.getCodeText = "发送短信";
          }
        }, 1000);
      }
    },
    changePassword(paramArr) {
      let _this = this;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["changePassword"]["method"],
          url: apiMap["changePassword"]["url"],
          data: paramArr.join("&"),
        })
        .then(function (response) {
          if (response.data.result.statusCode == 1) {
            _this.$alert("设置新密码成功，请前往登录", {
              confirmButtonText: "确定",
              showClose: false,
              callback: (action) => {
                _this.$router.push("/login");
              },
            });
          } else {
            _this.$alert(response.data.result.data, {
              confirmButtonText: "确定",
              showClose: false,
            });
          }
        });
    },
  },
};
</script>
<style scoped>
.register-wrapper {
  width: 1200px;
  height: 950px;
  margin: 0 auto;
}

.regitster-logo-wrap {
  padding: 115px 0 50px;
  justify-content: center;
}

.regitster-form-wrap {
  width: 1100px;
  height: 600px;
  margin: 0 auto;
  background-color: #fff;
}

.password-form-wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 1100px;
  height: 600px;
  margin: 0 auto;
  background-color: #fff;
}

.register-text {
  height: 150px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  line-height: 150px;
}

.register-form-container {
  width: 505px;
  margin: 0 auto;
}

.password-form-container {
  width: 505px;
  margin: 0 auto;
}

.address-tip {
  margin-left: 100px;
  margin-bottom: 5px;
}

.get-code-btn {
  margin-left: 10px;
}

.agreement-wrap {
  margin-bottom: 10px;
}

.agreement-link {
  margin: 0 6px;
  color: #1a70db;
}

.use-agreement-container {
  height: 600px;
  padding: 10px;
  font-size: 16px;
  line-height: 30px;
  overflow-y: auto;
}

.sub-content {
  padding-left: 30px;
}

.agreement-indent {
  text-indent: 33px;
}

.inscribe-wrap {
  text-align: right;
}
</style>